import { useEffect, useState } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";

import { useNavigate, useParams } from "react-router-dom";
import LoadingComp from "../../components/re-usable/loading/loading";
import CoursesTabContent from "../../components/tabs/courses-tab-content";
import TwoColumnLayOut from "../../layouts/two-columns/two-column-layout";
import { retrieveCatalogPath } from "../../redux/slice/education/catalog-path-slice";
import { retrieveCatalogTabs } from "../../redux/slice/education/catalog-tabs-slice";
import { RootState, useAppDispatch } from "../../redux/store";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";

const Courses = () => {
  const navigator = useNavigate();
  const params = useParams()
  const dispatch = useAppDispatch()
  const [tabName, setTabName] = useState<string>(params.tabName || 'online-courses')
  const [pageNumber, setPageNumber] = useState<number>(1)
  const { CatalogTabsData, CatalogTabsLoading } = useSelector((state: RootState) => state.CatalogTabs)
  const { CatalogPathData } = useSelector((state: RootState) => state.CatalogPath);
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const path = '%2FEducation%2FCourses';

  const [isPublished, setIsPublished] = useState(false);

  const pageTabsData = [
    {
      displayText: 'Online Courses',
      pathName: 'online-courses'
    },
    {
      displayText: 'Webcasts',
      pathName: 'ondemand'
    },
    {
      displayText: 'Bundles',
      pathName: 'bundles'
    },
    {
      displayText: 'Certificates',
      pathName: 'certificates'
    },
    {
      displayText: 'RAC Exam Prep',
      pathName: 'rac-exam-prep'
    }
  ]

  const queryParams = {
    path: tabName,
    pageNumber: pageNumber
  }

  const updateUrl = (
    tabName?: string,
  ) => {
    tabName && navigator(`/education/courses/${tabName}`);
  };


  useEffect(() => {
    dispatch(retrieveCatalogTabs(queryParams));
    dispatch(retrieveCatalogPath(path));
    dispatch(retrievePageMenu(path));
  }, [dispatch])

  useEffect(() => {
    dispatch(retrieveCatalogTabs(queryParams));
  }, [tabName, pageNumber])



  // On tab change
  const handleSearchType = (displayName: string) => {
    setTabName(displayName)
    setPageNumber(1)
    updateUrl(displayName)
  }

  // Choose page number
  const choosePageNumber = (pageNumber: number) => {
    setPageNumber(pageNumber)
  }

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData])

  if (!isPublished) return <LoadingComp />

  return <>
    <Helmet>
      <title>{RapsEuropeData[0]?.result[0]?.menuItemName}</title>
    </Helmet>
    <TwoColumnLayOut breadcrumbPath={''} isBreadcrumbpath={false} showAds={true}>
      <div dangerouslySetInnerHTML={{ __html: CatalogPathData[0]?.text }}></div>
      <div className="tabbs courses">
        <Tab.Container id="left-tabs-example" defaultActiveKey={params.tabName || 'online-courses'} >
          <Row>
            <Col sm={12}>
              <Nav className="d-flex nav-tabs flex-wrap" >
                {
                  pageTabsData && pageTabsData?.map((tab, index) => {
                    const displayText = tab.pathName;
                    return <Nav.Item key={index} >
                      <Nav.Link eventKey={tab.pathName} onClick={() => handleSearchType(displayText)}>
                        <span className="searchtag" style={{ verticalAlign: 'top' }}>{tab.displayText}</span>
                      </Nav.Link>
                    </Nav.Item>
                  })
                }
              </Nav>
            </Col>
            {(CatalogTabsLoading) ? <LoadingComp /> : (

              <Col sm={12}>
                <Tab.Content className="category">
                  <Tab.Pane eventKey="online-courses" >
                    <CoursesTabContent tabContent={CatalogTabsData} choosePageNumber={choosePageNumber} pageNumber={pageNumber} isPagination={true} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="ondemand" >
                    <CoursesTabContent tabContent={CatalogTabsData} choosePageNumber={choosePageNumber} pageNumber={pageNumber} isPagination={true} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="bundles" >
                    <CoursesTabContent tabContent={CatalogTabsData} choosePageNumber={choosePageNumber} pageNumber={pageNumber} isPagination={false} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="certificates" >
                    <CoursesTabContent tabContent={CatalogTabsData} choosePageNumber={choosePageNumber} pageNumber={pageNumber} isPagination={true} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="rac-exam-prep" >
                    <CoursesTabContent tabContent={CatalogTabsData} choosePageNumber={choosePageNumber} pageNumber={pageNumber} isPagination={false} />
                  </Tab.Pane>
                </Tab.Content>

              </Col>
            )}

          </Row>
        </Tab.Container>
      </div>
    </TwoColumnLayOut></>
}

export default Courses

